import React from 'react';
import { motion } from 'framer-motion';
import { Target, MonitorSmartphone, Package } from 'lucide-react';
const pilares = [{
  icon: Target,
  image: 'https://cdn.magicpatterns.com/uploads/7TtbVWvUyL6uaR38hnUiLQ/Book_with_red_202604041654.jpg',
  label: 'Pilar 1',
  title: 'Arbitraje de Demanda Real',
  description: 'Interceptamos la necesidad del mercado. Cero adivinanzas, solo datos.'
}, {
  icon: MonitorSmartphone,
  image: 'https://cdn.magicpatterns.com/uploads/vc92z4S25XY1xbeTpkDUE5/Futuristic_vending_machine_202604041656.jpg',
  label: 'Pilar 2',
  title: 'Tu Máquina de Ventas',
  description: 'Estructura configurada para vender con Pago Contra Entrega y Pagos Anticipados. Maximizamos cada visita.'
}, {
  icon: Package,
  image: 'https://cdn.magicpatterns.com/uploads/5MtJnk7Wfi6bK2eCdLMxcT/Futuristic_box_with_202604041700.jpg',
  label: 'Pilar 3',
  title: 'Logística Invisible',
  description: 'Bodegas locales en el país donde decidas vender. El sistema despacha desde el origen, tú cobras tu margen.'
}];
export function TriangleMechanism() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto relative" data-id="element-120">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="text-center mb-16" data-id="element-121">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6" data-id="element-122">
          Los 3 Pilares de "El Código"
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-123">
        {pilares.map((pilar, index) => {
        const Icon = pilar.icon;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white/[0.03] backdrop-blur-xl border border-primary/20 rounded-2xl overflow-hidden relative z-10 shadow-[0_8px_32px_0_rgba(255,31,31,0.08)] ${index === 1 ? 'md:-translate-y-6' : ''}`} data-id="element-124">
              <div className="relative h-48 overflow-hidden" data-id="element-125">
                <img src={pilar.image} alt={pilar.title} className="w-full h-full object-cover" data-id="element-126" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" data-id="element-127" />
                <div className="absolute bottom-4 left-4" data-id="element-128">
                  <div className="w-10 h-10 rounded-lg bg-primary/20 backdrop-blur-sm flex items-center justify-center" data-id="element-129">
                    <Icon className="w-5 h-5 text-primary" data-id="element-130" />
                  </div>
                </div>
              </div>
              <div className="p-7" data-id="element-131">
                <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-132">
                  {pilar.label}
                </h3>
                <h4 className="text-lg font-bold text-primary mb-3" data-id="element-133">
                  {pilar.title}
                </h4>
                <p className="text-gray-300 font-medium leading-relaxed text-sm" data-id="element-134">
                  {pilar.description}
                </p>
              </div>
            </motion.div>;
      })}
      </div>
    </section>;
}